// src/components/Footer.js
import ScrollToTop from "react-scroll-up";
import {
  Box,
  Button,
  Container,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import GoogleTranslate from "./google-translate/googleTranslate";

function Footer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Container maxWidth="xxl" sx={{ mt: "auto", px: "0px !important" }}>
      <Box
        display={"flex"}
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent={"space-between"}
        alignItems={"center"}
        component="footer"
        gap={1}
        py={{ xs: 4, md: 3 }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            position: { md: "absolute" },
          }}
        >
          <GoogleTranslate />
        </Box>
        <Typography
          variant="body2"
          color="secondary.text"
          sx={{
            width: {
              xs: "80%",
              sm: "100%",
            },
            textAlign: "center",
            mt: { xs: 1, sm: 0 },
          }}
        >
          COPYRIGHT © {new Date().getFullYear()} BYLD Network, All rights
          reserved
        </Typography>
        <ScrollToTop
          showUnder={160}
          style={{
            bottom: "20px",
            zIndex: 1000,
            ...(isMobile ? { left: "20px" } : { right: "160px" }),
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            sx={{
              px: 1,
              py: 1,
              margin: 0,
              "& .MuiButton-startIcon": {
                margin: 0,
              },
            }}
            startIcon={<KeyboardArrowUpIcon />}
          />
        </ScrollToTop>
      </Box>
    </Container>
  );
}

export default Footer;